import {
  Box, ListItemIcon, ListItemText, MenuItem, Popover, Typography,
} from '@mui/material';
import { languages } from '@config';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

export default function LanguagePopover(props) {
  const {
    anchorEl, onClose, open, ...other
  } = props;
  const { i18n, t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const router = useRouter();

  const handleChange = (language) => {
    onClose?.();
    const lang = languages.find((l) => l.lang === language);

    const { pathname, asPath, query } = router;
    router.push({ pathname, query }, asPath, { locale: language });
    i18n.changeLanguage(language);

    enqueueSnackbar(
      t('components.LanguagePopover.notifications.languageChanged', {
        lang: lang.label,
      }),
      {
        variant: 'success',
      },
    );
  };

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'bottom',
      }}
      keepMounted
      onClose={onClose}
      open={open}
      transitionDuration={0}
      {...other}
      slotProps={{
        paper: { sx: { width: 240 } },
      }}
    >
      {languages.map((item) => (
        <MenuItem
          key={item.lang}
          onClick={() => handleChange(item.lang)}
          sx={{ py: 1 }}
        >
          <ListItemIcon>
            <Box
              sx={{
                display: 'flex',
                height: 20,
                width: 20,
                '& img': {
                  width: '100%',
                },
              }}
            >
              <img
                alt={item.label}
                src={item.icon}
              />
            </Box>
          </ListItemIcon>
          <ListItemText
            primary={(
              <Typography variant="subtitle2">
                {item.label}
              </Typography>
            )}
          />
        </MenuItem>
      ))}
    </Popover>
  );
}

LanguagePopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

LanguagePopover.defaultProps = {
  anchorEl: null,
  onClose: null,
  open: false,
};
